module.exports = {"id":"dp1_1l1q2","text":"Search, Browse and Filter Information","instructions":"Search results can change based on how a search is written.","multiselect":false,"category":"1.1","questionType":"PickOne","random":false,"options":[{"id":"dp1_1l1q2-a1","text":"True","score":1.8},{"id":"dp1_1l1q2-a2","text":"Not sure","score":0},{"id":"dp1_1l1q2-a3","text":"False","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.1/l1q2.json
// module id = 922
// module chunks = 41